import React, { type FC } from 'react'
import { TableCell, TableRow } from '@mui/material'

import { isTranslation, type Translation } from '../../../../domain'

import { CircularLoader, TypographyLoader } from '..'
import { FormattedTranslation } from '../../Internationalization'
import { useColspan, useSearchThreshold } from './State'

export const LoadingTableBody: FC<{ loading: true | Translation }> = ({ loading }) => {
    const colSpan = useColspan()
    const threshold = useSearchThreshold()

    return (
        <TableRow data-testid="loading-table">
            <TableCell colSpan={colSpan}>
                {isTranslation(loading) ? (
                    <TypographyLoader variant="body2">
                        <FormattedTranslation id={loading} values={{ threshold }} />
                    </TypographyLoader>
                ) : (
                    <CircularLoader />
                )}
            </TableCell>
        </TableRow>
    )
}
